module.exports = __webpack_public_path__ + "img/sld_scb_9_t1_b1_dark.020bc6b5.svg";